import { formatUberPickupWindow } from '@/utils/calendar'
import { formatDate } from 'date-fns'
import { asCurrency } from 'lib/utilities/number'
import { ShipmentDetailsModalProps } from '../ShipmentDetailsModal'

export type ShipmentDetailsModalInfoListProps = Pick<
  ShipmentDetailsModalProps,
  | 'pickup'
  | 'pickup_date'
  | 'delivery_by'
  | 'service'
  | 'insurance_cents'
  | 'uberPickup'
  | 'pickupReadyTime'
  | 'pickupCloseTime'
  | 'originTimeZone'
> & {
  canViewInsurance?: boolean
}

interface ShipmentDetailsModalInfoListItemProps {
  heading: string
  content: string
}

const ShipmentDetailsModalInfoListItem = ({
  heading,
  content,
}: ShipmentDetailsModalInfoListItemProps) => (
  <div>
    <dt className="type-body-7">{heading}</dt>
    <dd className="type-body-10 mt-2">{content}</dd>
  </div>
)

export default function ShipmentDetailsModalInfoList({
  pickup = true,
  pickup_date,
  delivery_by,
  service,
  insurance_cents,
  canViewInsurance = false,
  uberPickup,
  pickupReadyTime,
  pickupCloseTime,
  originTimeZone,
}: ShipmentDetailsModalInfoListProps) {
  return (
    <div className="rounded-8 bg-neutral-200 px-4 py-6 lg:flex-[0.56]">
      <dl className="grid grid-cols-2 gap-4 lg:gap-x-16">
        <ShipmentDetailsModalInfoListItem heading="Service" content={service} />
        {canViewInsurance && (
          <ShipmentDetailsModalInfoListItem
            heading="Insurance"
            content={asCurrency(insurance_cents / 100)}
          />
        )}
        <ShipmentDetailsModalInfoListItem
          heading={pickup ? 'Pickup Date' : 'Dropoff Date'}
          content={formatDate(pickup_date + 'T00:00:00', 'MM/dd/yyyy')}
        />
        <ShipmentDetailsModalInfoListItem
          heading="Delivery Date"
          content={formatDate(delivery_by + 'T00:00:00', 'MM/dd/yyyy')}
        />
        {uberPickup && (
          <ShipmentDetailsModalInfoListItem
            heading="Handling Method"
            content="Uber Pickup"
          />
        )}
        {uberPickup && pickupReadyTime && pickupCloseTime && (
          <ShipmentDetailsModalInfoListItem
            heading="Pickup Window"
            content={formatUberPickupWindow(
              pickupReadyTime,
              pickupCloseTime,
              originTimeZone,
            )}
          />
        )}
      </dl>
    </div>
  )
}
